<section class="wallet-page" dir="rtl">
  <nb-card>
    <nb-card-header class="card-header-row">
      <div class="title">
        <span class="icon-wrap">
          <nb-icon icon="credit-card-outline"></nb-icon>
        </span>
        <div>
          <strong>برداشت‌ها</strong>
          <small>مدیریت و تأیید درخواست‌های برداشت</small>
        </div>
      </div>

      <div class="header-actions">
        <span class="count">{{ total | number }} درخواست</span>
        <button
          *ngIf="hasFilters"
          nbButton
          size="small"
          status="basic"
          type="button"
          (click)="clearSearch()"
        >
          پاک کردن جست‌وجو
        </button>
        <button
          nbButton
          ghost
          size="small"
          status="primary"
          type="button"
          (click)="loadItems()"
          [disabled]="loading"
        >
          <nb-icon icon="refresh-outline"></nb-icon>
          بروزرسانی
        </button>
      </div>
    </nb-card-header>

    <nb-card-body [attr.aria-busy]="loading">
      <div *ngIf="loading" class="state-box" role="status">
        <nb-icon icon="loader-outline"></nb-icon>
        <span>در حال دریافت درخواست‌ها...</span>
      </div>

      <div *ngIf="!loading && errorMessage" class="state-box state-box--error" role="alert">
        <nb-icon icon="alert-circle-outline"></nb-icon>
        <span>{{ errorMessage }}</span>
        <button nbButton size="tiny" status="danger" (click)="loadItems()">
          تلاش دوباره
        </button>
      </div>

      <div class="table-wrap">
        <ng2-smart-table
          class="rtl-table"
          [settings]="settings"
          [source]="source"
        ></ng2-smart-table>
      </div>

      <ngx-pagination
        *ngIf="!loading && !errorMessage"
        [total]="total"
        [perPage]="perPage"
        [page]="currentPage"
        (changePage)="handleChangePage($event)"
      ></ngx-pagination>
    </nb-card-body>
  </nb-card>
</section>
